import moment, { months } from 'moment';
import memoize from 'fast-memoize';

/**
 * Formatting the date
 * @param dateStr date string in ISO format
 * @returns date in MM/DD/YYYY
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const dateFormat = memoize((dateStr: string) => {
    return moment(dateStr).format('MM/DD/YYYY');
});

export const nextPaymentDateDiff = memoize((dateStr: string) => {
    if (moment(dateStr).year() > moment().year()) {
        const today = moment([moment().year(), moment().month()]);
        const nextPayDate = moment([moment(dateStr).year(), moment(dateStr).month()]);
        return nextPayDate.diff(today, 'months');
    } else {
        return moment(dateStr).month() - moment().month();
    }
});

export const dateOnlyMonthFormat = (dateStr: string) => {
    return moment(dateStr).format('MMMM');
};
export const dateMonthFormat = (dateStr: string) => {
    return moment(dateStr).format('MMMM Do');
};
